/**
 * @file Main view handler module.
 * This module imports various components and instantsearch modules, and initializes them.
 * It is responsible for setting up the user interface components of the application.
 */
import "./instantsearch/members-searcher";
import "./instantsearch/partners-searcher";
import "./instantsearch/actions-searcher";
import "./instantsearch/global-network-searcher";
import "./instantsearch/resources-autocomplete-searcher";
import "./instantsearch/resources-results-searcher";
import "./instantsearch/resources-searcher";
import "./instantsearch/autocomplete";
import "./instantsearch/news-searcher";
import "./instantsearch/news-autocomplete-searcher";
import "./instantsearch/news-results-searcher";
import "./instantsearch/search-page";

import HeaderController from "./Components/HeaderController";
import DropdownController from "./Components/DropdownController";
import HomeCarouselController from "./Components/HomeCarouselController";
import ActionMemberCarouselController from "./Components/ActionMemberCarouselController";
import CubeHeroController from "./Components/CubeHeroController";
import AutoScrollController from "./Components/AutoScrollController";
import OutlineScrollController from "./Components/OutlineScrollController";
import TrendingNewsCarousel from "./Components/TrendingNewsCarousel";
import EventsController from "./Components/EventsController";
import PastEventsController from "./Components/PastEventsController";
import SearchController from "./Components/SearchPage/SearchController";
import PageNotFoundSearcherController from "./Components/PageNotFoundSearcherController";
import HomeCubeController from "./Components/HomeCubeController";
import ErrorPageController from "./Components/ErrorPageController";
import TagsController from "./Components/TagsController";
import LogoCarousel from "./Components/LogoCarousel";
import NewsletterForm from "./Components/NewsletterForm";

/**
 * ViewHandler object responsible for initializing various components of the application.
 * It coordinates the setup of the user interface by initializing each component.
 */
const ViewHandler = {
  /**
   * Initializes all the components used in the application.
   * This method sequentially calls the `init` method on each imported controller.
   * Controllers initialized include Header, Dropdown, Carousels, and various page-specific controllers.
   */
  init() {
    HeaderController.init();
    DropdownController.init();
    HomeCarouselController.init();
    ActionMemberCarouselController.init();
    CubeHeroController.init();
    AutoScrollController.init();
    OutlineScrollController.init();
    TrendingNewsCarousel.init();
    EventsController.init();
    PastEventsController.init();
    SearchController.init();
    PageNotFoundSearcherController.init();
    HomeCubeController.init();
    ErrorPageController.init();
    TagsController.init();
    LogoCarousel.init();
    NewsletterForm.init();
  },
};

export default ViewHandler;
